module.exports = __webpack_public_path__ + "img/title-w.911f99eb.svg";